import React, { Component } from 'react'
import 'moment-timezone'
import moment from 'moment'
import './sessions.css'
import './buttonSlider.css'
import TitleBar from '../TitleBar'
import Carousel from '../Carousel'
import SessionFilterScreen from '../SessionFilterScreen'
import getLabel from '../../utilities/label.js'
import SessionRow from './SessionRow.js'
import PeerToPeerRow from './PeerToPeerRow.js'
import OneOnOneRow from './OneOnOneRow.js'

import _ from 'lodash'

export default class Sessions extends Component {
  constructor(props) {
    super(props)
    this.props.setActiveTab('agenda')
    const agendaFilters = this.getAgendaFilters()
    this.state = {
      isRefreshing: false,
      showFilterScreen: false,
      agendaFilters: agendaFilters,
      sessions: this.filterSessions(agendaFilters),
      users: this.getUsers(),
      currentUser: window.currentUser,
      oneOnOneWizardIsComplete: props.oneOnOneWizardIsComplete
    }
    this.scrollToCurrentSession = this.scrollToCurrentSession.bind(this)
    this.refresh = this.refresh.bind(this)
    this.getSessions = this.getSessions.bind(this)
    this.toggleFilter = this.toggleFilter.bind(this)
    this.toggleFilterScreen = this.toggleFilterScreen.bind(this)
    this.resetFilters = this.resetFilters.bind(this)
    window.trackPage('AgendaScreen')
  }

  getAgendaFilters() {
    const agendaFilters = JSON.parse(localStorage.getItem('agenda_filters'))
    return agendaFilters || this.getDefaultFilters()
  }

  getUsers() {
    const userList = JSON.parse(localStorage.getItem('users')).event_users
    return userList
  }

  getUser(userId) {
    const user = this.state.users.find(user => user.user_id == userId)
    return user
  }

  getDefaultFilters() {
    return {
      mySchedule: false,
      registrationRequired: false,
      tracks: this.getCategoryObject('track_name'),
      types: this.getCategoryObject('session_type'),
      rooms: this.getCategoryObject('room_name')
    }
  }

  getCategoryObject(fieldName) {
    let returnObj = {}
    const { sessions } = this.props.sessions
    const list =  _.uniq(_.compact(_.map(sessions, (session) => {
      return session[fieldName]
    })))
    list.forEach((item) => {
      returnObj[item] = false
    })
    return returnObj
  }

  filterSessions(agendaFilters) {
    let sessions = this.props.sessions.sessions
    // Filter 1, mySchedule
    if (agendaFilters.mySchedule) {
      let inScheduleStatuses = [
        'un_register'
      ]
      sessions = sessions.filter((session) => {
        return inScheduleStatuses.includes(session.registration_status)
      })
    }
    // Filter 2, registrationRequired
    if (agendaFilters.registrationRequired) {
      sessions = sessions.filter((session) => {
        return session.registration_required
      })
    }
    // Filter 3, tracks
    if (_.some(agendaFilters.tracks)) {
      const trackNames = this.getActive(agendaFilters.tracks)
      sessions = sessions.filter((session) => {
        return trackNames.includes(session.track_name)
      })
    }
    // Filter 4, session_types
    if (_.some(agendaFilters.types)) {
      const typeNames = this.getActive(agendaFilters.types)
      sessions = sessions.filter((session) => {
        return typeNames.includes(session.session_type)
      })
    }
    // Filter 5, rooms
    if (_.some(agendaFilters.rooms)) {
      const roomNames = this.getActive(agendaFilters.rooms)
      sessions = sessions.filter((session) => {
        return roomNames.includes(session.room_name)
      })
    }
    return sessions
  }

  getActive(filterObject) {
    let names = _.keys(filterObject)
    return names.filter((name) => {
      return filterObject[name]
    })
  }

  hasAnyFiltersActive() {
    const { agendaFilters } = this.state
    return (
      agendaFilters['mySchedule'] ||
      agendaFilters['registrationRequired'] ||
      _.some(agendaFilters.tracks) ||
      _.some(agendaFilters.types) ||
      _.some(agendaFilters.rooms)
    )
  }

  toggleFilter(filterKey, secondaryKey) {
    let { agendaFilters } = this.state
    if (secondaryKey) {
      agendaFilters[filterKey][secondaryKey] = !agendaFilters[filterKey][secondaryKey]
    } else {
      agendaFilters[filterKey] = !agendaFilters[filterKey]
    }
    localStorage.setItem('agenda_filters', JSON.stringify(agendaFilters))
    this.updateSessions(agendaFilters)
  }

  resetFilters() {
    const agendaFilters = this.getDefaultFilters()
    localStorage.setItem('agenda_filters', JSON.stringify(agendaFilters))
    this.updateSessions(agendaFilters)
  }

  updateSessions(agendaFilters) {
    let sessions = this.filterSessions(agendaFilters)
    this.setState({
      sessions: sessions,
      agendaFilters: agendaFilters
    })
  }

  toggleFilterScreen() {
    this.setState({
      showFilterScreen: !this.state.showFilterScreen
    })
  }

  componentDidMount() {
    this.scrollToCurrentSession()
  }

  scrollToCurrentSession() {
    const { currentEvent } = this.props
    const eventBeginDate = moment(currentEvent.begin_date).utcOffset(0)
    const eventEndDate = moment(currentEvent.end_date).utcOffset(0)
    const now = moment().utcOffset(0, true)
    if (eventBeginDate.diff(now) < 0 && eventEndDate.diff(now) > 0) {
      this.getTimeBlocks().some((timeBlock, index) => {
        let timeBlockTime = moment(timeBlock).utcOffset(0)
        if (timeBlockTime.diff(now, 'minutes') > 0) {
          let id = 'time-block-index-' + (index - 1)
          let el = document.getElementById(id)
          el.scrollIntoView()
          return true
        } else { return false }
      })
    }
  }

  getTimeBlocks() {
    let timeBlocks = []
    let currentStartStamp = null
    this.state.sessions.forEach((session) => {
      if(session.day_start_stamp !== currentStartStamp) {
        timeBlocks.push(session.day_start_stamp)
        currentStartStamp = session.day_start_stamp
      }
    })
    return timeBlocks
  }

  refresh() {
    this.setState({ ['sessions']: [] })
    if (this.state.isRefreshing) {
      return
    } else {
      this.setState(
        { isRefreshing: true },
        this.props.getResource({
          key: 'sessions',
          update: true,
          callback: () => {
            this.setState({
              isRefreshing: false
            }, this.resetFilters)
          }
        })
      )
    }
  }

  findBlockedTimeBlocks() {
    let p2pOptedInTimeBlocks = []
    let currentStartStamp = null
    let timeBlockIndex = 0
    this.state.sessions.forEach((session) => {
      if(!session.is_hidden){
        if(session.day_start_stamp !== currentStartStamp) {
          timeBlockIndex += 1
          currentStartStamp = session.day_start_stamp
        }
        if (session.session_type == 'Peer-to-Peer Meetings') {
          p2pOptedInTimeBlocks.push(timeBlockIndex)
        }
      }
    })
    return p2pOptedInTimeBlocks
  }

  getSessions() {
    let sessions = []
    let currentStartStamp = null
    let timeBlockIndex = 0
    let blockedTimeBlocks = this.findBlockedTimeBlocks()
    this.state.sessions.forEach((session) => {
      if(!session.is_hidden){
        if(session.day_start_stamp !== currentStartStamp) {
          timeBlockIndex += 1
          sessions.push( this.getTimeBlockHeader(session, timeBlockIndex))
          currentStartStamp = session.day_start_stamp
        }
        let sessionRow = session.itinerary ?
          this.getSessionItinerary(session, timeBlockIndex) :
          this.getSession(session, timeBlockIndex, blockedTimeBlocks)
        sessions.push(sessionRow)
      }
    })
    const noResultsMessage = (
      <div className="no-results-message">
        { getLabel('no_results_found') }
      </div>
    )
    return sessions.length ? sessions : noResultsMessage
  }

  getTimeBlockHeader(session, timeBlockIndex) {
    return (
      <div
        key={ session.day_start_stamp }
        id={ 'time-block-index-' + timeBlockIndex } >
        <div className='session-time'>
          { session.formatted_display_date }
        </div>
        <div className='clear'></div>
      </div>
    )
  }

  getSessionItinerary(session, timeBlockIndex) {
    return (
      <div
        key={ session.id }
        alt={ timeBlockIndex }
        className='session itinerary'>
        <p className='session-name'>{ session.name }</p>
      </div>
    )
  }

  getP2P(meeting, session) {
    // unique key needed here. meeting.id is null fairly often.
    return (
      <OneOnOneRow
        key={ meeting.id }
        p2p={ meeting }
        session={ session }
        participant={ this.getUser(meeting.participant_user_id) }
      />
    )
  }

  getP2Ps(session) {
    let meetings = []
    if(session.one_on_one_wizard_is_complete != null) {
      session.one_on_one_meetings.forEach((meeting) => {
        let meetingRow = this.getP2P(meeting, session)
        meetings.push(meetingRow)
      })
      return _.sortBy(meetings, function(meeting) {
        return meeting.props.p2p.epoch_start_time
      })
    }
  }

  getSession(session, timeBlockIndex, p2pOptedInTimeBlocks) {
    // here we check if we are in timeblock with p2p opted in
    if (p2pOptedInTimeBlocks.includes(timeBlockIndex) == true) {
      if (session.session_type_key == 'session_type_one_to_one_meeting') {
        return (
          <div alt={ timeBlockIndex }>
            <PeerToPeerRow
              key={ session.id }
              session={ session }
            />
            { this.getP2Ps(session) }
          </div>
        )
      } else {
        return (
          <div alt={ timeBlockIndex }>
            <SessionRow
              disabled={ true }
              alt={ timeBlockIndex }
              key={ session.id }
              session={ session }
              postResource={ this.props.postResource }
              flashMessage={ this.props.flashMessage }
            />
          </div>
        )
      }
    } else {
      if (session.session_type == 'Peer-to-Peer Meetings') {
        return (
          <div alt={ timeBlockIndex }>
            <PeerToPeerRow
              key={ session.id }
              session={ session }
            />
          </div>
        )
      } else {
        return (
          <div alt={ timeBlockIndex }>
            <SessionRow
              alt={ timeBlockIndex }
              key={ session.id }
              session={ session }
              postResource={ this.props.postResource }
              flashMessage={ this.props.flashMessage }
            />
          </div>
        )
      }
    }
  }

  render() {
    const buttonStatus = this.state.agendaFilters['mySchedule']
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    const refreshButton = this.state.isRefreshing ?
      '<i class=\'fa fa-refresh fa-spin\'></i>' :
      '<i class=\'fa fa-refresh\'></i>'
    const filterLabel = this.hasAnyFiltersActive() ?
      getLabel('filter_on') :
      getLabel('filter_off')

    if (this.state.showFilterScreen) {
      return (
        <SessionFilterScreen
          resetFilters={ this.resetFilters }
          sessions={ this.props.sessions.sessions }
          agendaFilters={ this.state.agendaFilters }
          toggleFilter={ this.toggleFilter }
          toggleFilterScreen={ this.toggleFilterScreen } />
      )
    }

    return (
      <div className='sessions-page'>
        <TitleBar
          title={ this.props.pageTitle }
          leftButtonLabel={ backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ refreshButton }
          rightButtonAction={ this.refresh } />
        <div>
          <Carousel sponsors={ this.props.sponsors.sponsors } />
        </div>
        <div className="filter-bar">
          <a onClick={ this.toggleFilterScreen } className="custom-filter">{ filterLabel }</a>
          <div className="schedule-filter">
            <span>{ getLabel('my_schedule') }</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={ buttonStatus }
                onChange={ () => this.toggleFilter('mySchedule') } />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        { this.getSessions() }
      </div>
    )
  }
}
